import {
  SET_MAP_VISIBLE_POSTS
} from './constants'

export function setMapVisiblePosts (data = []) {
  return {
    type: SET_MAP_VISIBLE_POSTS,
    data
  }
}

export function reducer (state, action) {
  switch (action.type) {
    case SET_MAP_VISIBLE_POSTS:
      return {
        ...state,
        mapVisiblePosts: action.data
      }

    default:
      return state
  }
}
